import styled from 'styled-components';

export const CardContainer = styled.div`
  padding: 10px 0;
`;
